import { motion } from 'framer-motion'

import { Text, NotButton } from '@ds'
import { DiamondAnimation } from '@shared'

import { useProfileAvatarsActionsContext } from '../../../../contexts'
import { DustButtonIcon } from './DustButtonIcon'
import { GiftButtonIcon } from './GiftButtonIcon'
import styles from './ProfileAvatarsActions.module.scss'
import { SellButtonIcon } from './SellButtonIcon'

export const ProfileAvatarsActions = () => {
  const { selectedAvatar } = useProfileAvatarsActionsContext()

  return (
    <div className={styles.container}>
      <Text align="center" type="h1" className={styles.title}>
        More
      </Text>

      <div className={styles.videoWrapper}>
        <svg viewBox="0 0 199 183" fill="none" className={styles.diamond}>
          <DiamondAnimation optimized />
        </svg>
        <motion.video
          key={selectedAvatar}
          src={selectedAvatar}
          autoPlay
          loop
          muted
          playsInline
          width="100%"
          height="auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.5 } }}
          exit={{ opacity: 0, transition: { duration: 0.6 } }}
        />
      </div>

      <div className={styles.actionButtonsContainer}>
        <NotButton className={styles.actionButton} variant="total-black">
          <SellButtonIcon /> <Text className={styles.buttonText}>Sell</Text>
        </NotButton>
        <NotButton className={styles.actionButton} variant="total-black">
          <GiftButtonIcon />
          <Text className={styles.buttonText}>Send as a gift</Text>
        </NotButton>
        <NotButton className={styles.actionButton} variant="total-black">
          <DustButtonIcon /> <Text className={styles.buttonText}>Dust</Text>
        </NotButton>
      </div>
    </div>
  )
}
